import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  get_atEnd1cw5d2zgug26 as get_atEnd,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  newTasksAllowed26ihc5f4iqgon as newTasksAllowed,
  newTasksAllowed2g7c6d9oaegnt as newTasksAllowed_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import {
  notificationBar4efejtg2792g as notificationBar,
  dismissableBanner3s49vuosvr23r as dismissableBanner,
} from '../../../../theming/banners.mjs';
import {
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../../../../utils/utils.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../../../theming/Titles.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_boldStrongTag3a2aqno8aede0 as get_boldStrongTag } from '../../../../../actuals/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { inlineKeyString1hdvsz76w276 as inlineKeyString } from '../../../keyValue.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { renderPunchListRow3mo466g522loq as renderPunchListRow } from './renderPunchlists.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { RootCreateItemTask3hcc6ixs4t028 as RootCreateItemTask } from '../../../../dialogs/LineItemDialogs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function projectTasks(_this__u8e3s4, project, lineItems, punchListItems, lens_0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(0));
  var expandedPunchLists = Signal().hak(emptySet());
  if (lens_0.equals(ProjectLens_Contractor_getInstance())) {
    var tmp = view.kbb(get_atEnd(view), get_tertiaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = Button$_get_enabled_$ref_61t7nx(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp;
      var tmp0 = $this$reactiveScope.daj(lineItems);
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (newTasksAllowed(element.mfy())) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp = newTasksAllowed_0($this$reactiveScope.daj(project).u7b_1);
      } else {
        tmp = false;
      }
      var tmp$ret$2 = tmp;
      this_0.set(tmp$ret$2);
      return Unit_instance;
    });
    specCenteredText(view_0, '+ Task');
    onClick(view_0, VOID, VOID, projectTasks$slambda_0(lineItems));
    view.hbb(p_0, view_0);
    view.lbb(tmp, view_0);
  }
  if (lens_0.equals(ProjectLens_Customer_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.zbm(true);
    view_1.bb9(get_rem(1));
    dismissableBanner(view_1, 'task info', ($this$dismissableBanner) => {
      var tmp = notificationBar($this$dismissableBanner, AppColors_getInstance().lfz_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (Frame())($this$dismissableBanner.pc());
      var tmp0_elvis_lhs = $this$dismissableBanner.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$dismissableBanner : tmp0_elvis_lhs;
      $this$dismissableBanner.gbb(p, view);
      shownDefaultFalse(view, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(project).u7b_1.d4(ProjectState_Accepted_getInstance()) >= 0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      view_0.zbm(true);
      view_0.bb9(get_AppDimensions().rg2_1);
      body(view_0, 'Tasks, created by the contractor, help you stay informed and ensure all work is completed as expected. You may want to request some specific tasks be listed.');
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Space())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      view_0.hbb(p_1, view_1);
      var tmp_0 = get_boldStrongTag(view_0);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.gbb(p_2, view_2);
      view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
      inlineKeyString(view_2, 'Punch List Tasks', "Loose ends to address during project closeout. Tasks marked as 'Required' are tied to the punch list and must be resolved before the project is finalized.");
      view_0.hbb(p_2, view_2);
      view_0.lbb(tmp_0, view_2);
      var tmp_1 = get_boldStrongTag(view_0);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_3 = view_0.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
      view_0.gbb(p_3, view_3);
      view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
      inlineKeyString(view_3, 'Work Item Tasks', 'These detail unique tasks to this work on your job, providing clarity on what\u2019s being done and building confidence in your contractor\u2019s process.');
      view_0.hbb(p_3, view_3);
      view_0.lbb(tmp_1, view_3);
      view.hbb(p_0, view_0);
      $this$dismissableBanner.hbb(p, view);
      return $this$dismissableBanner.lbb(tmp, view);
    });
    view.hbb(p_1, view_1);
  }
  var tmp_2 = notificationBar(view, AppColors_getInstance().lfz_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  shownDefaultFalse(view_2, ($this$shownDefaultFalse) => lens_0.equals(ProjectLens_Contractor_getInstance()) && $this$shownDefaultFalse.daj(project).u7b_1.d4(ProjectState_Complete_getInstance()) >= 0);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'You cannot create work items after the project has been completed';
  var tmp_3 = view_2.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = value;
  }
  tmp_3.hbu(tmp_4);
  view.hbb(p_2, view_2);
  view.lbb(tmp_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view.hbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.bb9(get_dp(0));
  var tmp0_title = _Constant___init__impl__v45mub('Punch Tasks');
  var tmp_5 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(expandedPunchLists).t1(null));
  var tmp1_expanded = withWrite(tmp_5, projectTasks$slambda_2(expandedPunchLists));
  var tmp2_items = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(punchListItems);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.l7w_1 == null || element.p7w_1 || !(element.s7w_1 == null)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var tmp3_rowHeight = get_rem(3);
  renderPunchListRow(view_4, new (Constant())(tmp0_title), tmp1_expanded, project, tmp2_items, null, true, lens_0, tmp3_rowHeight, '+ Punch Task', true);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.zbm(true);
  view_5.bb9(get_dp(0));
  var notComplete = lens(lineItems, projectTasks$lambda);
  forEachUpdating(view_5, notComplete, VOID, ($this$forEachUpdating, item) => {
    var tmp0_title = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(item).nf9_1);
    var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(expandedPunchLists).t1($this$remember.daj(item).mf9_1));
    var tmp1_expanded = withWrite(tmp, projectTasks$lambda$slambda_0(expandedPunchLists, item));
    var tmp2_items = remember(VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.daj(punchListItems);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (equals(element.l7w_1, $this$remember.daj(item).mf9_1)) {
          destination.v(element);
        }
      }
      return destination;
    });
    var tmp3_rowHeight = get_rem(3);
    renderPunchListRow($this$forEachUpdating, tmp0_title, tmp1_expanded, project, tmp2_items, item, VOID, lens_0, tmp3_rowHeight, VOID, false);
    return Unit_instance;
  });
  view_4.hbb(p_5, view_5);
  view.hbb(p_4, view_4);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.shl_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.mfy().d4(LineItemState_Complete_getInstance()) < 0) {
      destination.v(element);
    }
  }
  tmp.zgd(new (RootCreateItemTask())(destination));
  return Unit_instance;
}
var projectTasks$slambdaClass;
function projectTasks$slambda() {
  if (projectTasks$slambdaClass === VOID) {
    class $ {
      constructor($lineItems) {
        this.shl_1 = $lineItems;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectTasks$slambdaClass = $;
  }
  return projectTasks$slambdaClass;
}
function projectTasks$slambda_0($lineItems) {
  var i = new (projectTasks$slambda())($lineItems);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var projectTasks$slambdaClass_0;
function projectTasks$slambda_1() {
  if (projectTasks$slambdaClass_0 === VOID) {
    class $ {
      constructor($expandedPunchLists) {
        this.thl_1 = $expandedPunchLists;
      }
      cfz($this$withWrite, it, $completion) {
        if (it) {
          var _receiver__tnumb7 = this.thl_1;
          _receiver__tnumb7.oam(plus(_receiver__tnumb7.f2(), null));
        } else {
          var _receiver__tnumb7_0 = this.thl_1;
          _receiver__tnumb7_0.oam(minus(_receiver__tnumb7_0.f2(), null));
        }
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    projectTasks$slambdaClass_0 = $;
  }
  return projectTasks$slambdaClass_0;
}
function projectTasks$slambda_2($expandedPunchLists) {
  var i = new (projectTasks$slambda_1())($expandedPunchLists);
  var l = ($this$withWrite, it, $completion) => i.cfz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function projectTasks$lambda(items) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.mfy().d4(LineItemState_Complete_getInstance()) < 0) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_0($this, $this$withWrite, it, $completion) {
  if (it) {
    var _receiver__tnumb7 = $this.uhl_1;
    var tmp = _receiver__tnumb7.f2();
    var tmp_0 = awaitOnce($this.vhl_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    _receiver__tnumb7.oam(plus(tmp, tmp_0.mf9_1));
  } else {
    var _receiver__tnumb7_0 = $this.uhl_1;
    var tmp_1 = _receiver__tnumb7_0.f2();
    var tmp_2 = awaitOnce($this.vhl_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    _receiver__tnumb7_0.oam(minus(tmp_1, tmp_2.mf9_1));
  }
  return Unit_instance;
}
var projectTasks$lambda$slambdaClass;
function projectTasks$lambda$slambda() {
  if (projectTasks$lambda$slambdaClass === VOID) {
    class $ {
      constructor($expandedPunchLists, $item) {
        this.uhl_1 = $expandedPunchLists;
        this.vhl_1 = $item;
      }
      cfz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    projectTasks$lambda$slambdaClass = $;
  }
  return projectTasks$lambda$slambdaClass;
}
function projectTasks$lambda$slambda_0($expandedPunchLists, $item) {
  var i = new (projectTasks$lambda$slambda())($expandedPunchLists, $item);
  var l = ($this$withWrite, it, $completion) => i.cfz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
//region block: exports
export {
  projectTasks as projectTasks12j3aovmmzdca,
};
//endregion

//# sourceMappingURL=projectTasks.mjs.map
